<template>
    <div>
        <test-page-header
            :title=trans.statistics.session_details.title
            :is-one-line-title="true"
            :return-button="returnButton"
            :is-show-navigation="!isPublicForm"
        />

        <div class="fixed-with-overflow-y small-scrollbar">
            <div class="session-details mb-1">
                <div class="columns mx-0 mt-0 mb-1 p-0">
                    <div class="column is-two-fifths my-0 p-0">
                        {{ trans.statistics.session_details.questions_count }}
                    </div>
                    <div class="column  my-0 p-0">
                        {{ testStatisticSession.questions_count }}
                    </div>
                </div>
                <div
                    v-if="isHasSessionDetailsQuestionsWithPoints"
                    class="columns mx-0 mt-0 mb-1 p-0"
                >
                    <div class="column is-two-fifths my-0 p-0">
                        {{ trans.statistics.session_details.total_points }}
                    </div>
                    <div class="column  my-0 p-0">
                        {{ testStatisticSession.total_points }}
                    </div>
                </div>
                <div class="columns mx-0 mt-0 mb-1 p-0" v-if="isSessionHasSkipQuestions">
                    <div class="column is-two-fifths my-0 p-0">
                        {{ trans.statistics.session_details.show_skip_questions }}
                    </div>
                    <div class="column  my-0 p-0">
                        <toggle-button v-model="isShowSkipQuestions" :callback="setIsShowSkipQuestions"/>
                    </div>
                </div>
            </div>
            <statistics-question-list/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TestPageHeader from "../TestPageHeader";
import ToggleButton from "../../../utils/forms/ToggleButton";
import StatisticsQuestionList from "../statistics/questions/StatisticsQuestionList";

export default {
    name: "TestResultPage",
    components: {ToggleButton, TestPageHeader, StatisticsQuestionList},
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testStatisticSession',
            'isSessionHasSkipQuestions',
            'isShowSkipQuestions',
            'isPublicForm',
            'isHasSessionDetailsQuestionsWithPoints',
        ]),
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnToTestListPage,
            }
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestListPage',
            'setIsShowSkipQuestions',
        ]),
    }
}
</script>

<style scoped lang="scss">

.session-details {
    font-size: 18px;
    font-style: normal;

    & div:not(:last-child){
        margin-bottom: 5px;
    }
}
</style>